module.exports = __webpack_public_path__ + "static/media/6.01eb521d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/6.png
// module id = 921
// module chunks = 0